import { Form } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Radio from 'components/Form/RadioButton'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import {
  FooterFlex,
  LocationAdd,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import { DefaultDiv } from 'modules/Settings/Components/Location/style'
import React from 'react'
import { LocationDiv } from '../../ScheduleInterviewDrawer/InterviewerDrawer/style'

const ChangeLocation = ({
  setAddLocationDrawer,
  setCreateSlotDrawer,
  setChangeLocationDrawer,
  changeLocationDrawer,
  locations,
  getInterViewLocation,
  setSingleLocationChangeData,
  checked,
  setChecked,
}) => {
  const [locationForm] = Form.useForm()

  const onClose = () => {
    setChangeLocationDrawer(false)
    setCreateSlotDrawer(true)
  }

  const handleCheckboxChange = (value, data) => {
    if (checked === value) {
      setChecked(null)
      setSingleLocationChangeData(null)
    } else {
      setChecked(value)
      setSingleLocationChangeData(data)
    }
  }

  const addLocation = () => {
    setAddLocationDrawer(true)
    setChangeLocationDrawer(false)
  }

  const onSubmitFormData = async values => {
    setChangeLocationDrawer(false)
    getInterViewLocation()
  }

  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'locationForm'}
        form={locationForm}
        layout="vertical"
        onFinish={onSubmitFormData}
      >
        <div>
          {locations?.map(item => (
            <div key={item.id}>
              <Flex key={item.id} alignCenter>
                <Radio
                  key={item.id}
                  value={item.value}
                  checked={checked === item.id}
                  onChange={() => handleCheckboxChange(item.id, item)}
                  disable={true}
                />
                <LocationAdd>
                  <LocationDiv>
                    {item?.branchName} {item?.city}, {item?.state},{' '}
                    {item?.country} &nbsp;&nbsp;{' '}
                    {!!item?.defaultLocation && (
                      <DefaultDiv>Default</DefaultDiv>
                    )}
                  </LocationDiv>
                </LocationAdd>
              </Flex>
            </div>
          ))}
          <div style={{ marginTop: '40px' }}>
            <Button.Secondary
              text={'Add'}
              width="100%"
              icon={<PlusWhiteIcon />}
              dashed={true}
              onClick={addLocation}
            />
          </div>
        </div>
      </Form>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={onClose}
        />
        <Button.Primary
          width="69px"
          height="38px"
          text="Confirm"
          form={'locationForm'}
          htmlType="submit"
        />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Change Location'}
      placement="right"
      visible={changeLocationDrawer}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default ChangeLocation
